import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Processors act on an assigned company; append its id so scoped endpoints resolve it.
  const acting = localStorage.getItem("cs_acting_company");
  if (acting) config.params = { company_id: acting, ...(config.params || {}) };
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  return `${API}/files/${path}`;
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
